// sort-imports-ignore
import { Player } from 'bitmovin-player/modules/bitmovinplayer-core';
import EngineBitmovinModule from 'bitmovin-player/modules/bitmovinplayer-engine-bitmovin';
import MseRendererModule from 'bitmovin-player/modules/bitmovinplayer-mserenderer';
import HlsModule from 'bitmovin-player/modules/bitmovinplayer-hls';
import AbrModule from 'bitmovin-player/modules/bitmovinplayer-abr';
import ContainerTSModule from 'bitmovin-player/modules/bitmovinplayer-container-ts';
import SubtitlesModule from 'bitmovin-player/modules/bitmovinplayer-subtitles';
import SubtitlesCEA608Module from 'bitmovin-player/modules/bitmovinplayer-subtitles-cea608';
import PolyfillModule from 'bitmovin-player/modules/bitmovinplayer-polyfill';
import StyleModule from 'bitmovin-player/modules/bitmovinplayer-style';
import DashModule from 'bitmovin-player/modules/bitmovinplayer-dash';
import XmlModule from 'bitmovin-player/modules/bitmovinplayer-xml';
import EngineNativeModule from 'bitmovin-player/modules/bitmovinplayer-engine-native';
import DrmModule from 'bitmovin-player/modules/bitmovinplayer-drm';
import ContainerMP4Module from 'bitmovin-player/modules/bitmovinplayer-container-mp4';
import SubtitlesNativeModule from 'bitmovin-player/modules/bitmovinplayer-subtitles-native';
import SubtitlesTTMLModule from 'bitmovin-player/modules/bitmovinplayer-subtitles-ttml';

// Web Bitmovin player modules have to be imported and added in the predefined order,
// so we're using "sort-imports-ignore" to disable prettier modifications with imports.
function registerModules() {
    Player.addModule(EngineBitmovinModule);
    Player.addModule(MseRendererModule);
    Player.addModule(HlsModule);
    Player.addModule(XmlModule);
    Player.addModule(DashModule);
    Player.addModule(AbrModule);
    Player.addModule(ContainerTSModule);
    Player.addModule(SubtitlesModule);
    Player.addModule(SubtitlesCEA608Module);
    Player.addModule(SubtitlesNativeModule);
    Player.addModule(SubtitlesTTMLModule);
    Player.addModule(PolyfillModule);
    Player.addModule(StyleModule);
    Player.addModule(EngineNativeModule);
    Player.addModule(ContainerMP4Module);
    Player.addModule(DrmModule);
}

export default registerModules;
